module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/create.js
 ** module id = 439
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/